var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 17
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m12.667 16-5.834-4.167L1 16V2.667A1.667 1.667 0 0 1 2.667 1H11a1.667 1.667 0 0 1 1.667 1.667z"
})));
export default SvgBookmark;